export const apiUrl = process.env.REACT_APP_API_URL
export const imageUrl = process.env.REACT_APP_IMAGE_URL
export const certificatesUrl = process.env.REACT_APP_CERTIFICATES_URL

export const domain = 'https://cw.et360.de'

export const dateFormat = 'DD.MM.YYYY'

export const courseWareLogoColors = {
  primary: '#14CCAA',
  secondary: '#17375F',
}

export enum Currencies {
  EUR = 'EUR',
  CHF = 'CHF',
}

export const baseCurrency = Currencies.EUR